import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BYPASS_ERROR_400 } from './bypass-error.context-token';
import { ErrorResponseWithStatus, PASS_STATUS_CODE } from './bypass-status.context-token';
import { logError, throwResponseError, ResponseErrorMessage } from './error';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorBody = error.error;

        if (request.responseType === 'text') {
          try {
            errorBody = JSON.parse(errorBody);
          } catch {
            /* empty */
          }
        }

        switch (error.status) {
          case 500:
            logError(request, error, 'error');
            return throwResponseError('500 - Server error', request, error);
          case 400:
            if (!request.context.get(BYPASS_ERROR_400)) {
              logError(request, error, 'log');
            }
            return throwResponseError(errorBody?.detail || error.message || 'Error occurred', request, error);
          default:
            return throwResponseError(errorBody?.detail || error.message || 'Error occurred', request, error);
        }
      }),
      catchError(({ request, message, errorResponse }: ResponseErrorMessage) => {
        if (request.context.get(PASS_STATUS_CODE)) {
          const errorWithStatus: ErrorResponseWithStatus = { message, status: errorResponse.status };
          return throwError(errorWithStatus);
        }
        return throwError(message);
      }),
    );
  }
}
